export const calculateDiscountPrice = (cost,rate) => {
    let actualRate = rate ? rate : 0
    return parseInt(cost) - ((parseInt(actualRate) * parseInt(cost))/100)
}